import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { PersonInformationType, layoutOptions } from "./types/prop-types";

/** PersonInformation Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: [
    SecondaryBlockSize.Small,
    SecondaryBlockSize.Medium,
    SecondaryBlockSize.Large,
  ],
};

export const PersonInformation = secondaryBlock<PersonInformationType>(
  blockConfig,
  ({ image, name, company }: PersonInformationType) => (
    <Box className="secondary-person-information-name-description-v1">
      <Box className="margin-section-small">
        <Box className="testimonial5_client-image-wrapper testimonial5_client">
          {image.url && (
            <Variants.Image
              src={image.url}
              loading="lazy"
              alt={image.alt}
              className="testimonial5_client-image"
            />
          )}
        </Box>
        <Box className="testimonial5_client-info">
          {name && (
            <Variants.ParagraphDefault bold>{name}</Variants.ParagraphDefault>
          )}
          {company && (
            <Variants.ParagraphDefault>{company}</Variants.ParagraphDefault>
          )}
        </Box>
      </Box>
    </Box>
  )
);

PersonInformation.defaultProps =
  getDefaultProps<PersonInformationType>(defaults);

export const Element: KameleonElement = {
  component: PersonInformation,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
